// @flow

import * as React from 'react';
import Box from 'sail/Box';
import Toggle, {ToggleItem} from 'sail/Toggle';
import {useArticle, usePrefs, useLocation} from 'docs/data';
import {useActivePage} from 'docs/hooks';
import {useContentAnimation} from 'docs/shell/content/ContentAnimationProvider';

export const TerminalPageSelector = () => {
  const {article} = useArticle();
  const {setPrefs} = usePrefs();
  const activePage = useActivePage();
  const {replaceLocation} = useLocation();
  const {setAnimationDirection} = useContentAnimation();

  const activeIndex = article.pages.indexOf(activePage);

  return (
    <Box className="TerminalPageSelector">
      <Toggle type="radio">
        {article.pages.map((page, index) => (
          <ToggleItem
            key={index}
            label={page.title}
            checked={page === activePage}
            onChange={() => {
              setPrefs(page.prefs);
              setAnimationDirection(activeIndex, index);
              replaceLocation({query: page.prefs});
            }}
          />
        ))}
      </Toggle>
    </Box>
  );
};
